import axios from 'axios'
import { errorHandler } from '../exports/error_management'

// import { StorageCache } from '../exports/dataStorage'

// const storageKey = 'ams-order-notification-key'
const api = async (method, path, params) => axios[method](path, params)
const state = {
    item: null,
    toggle: null,
    count: null,
    items: [],
    new_notification:null
}

const mutations = {
    set_item(state, payload) {
        state.item = payload
    },
    set_count(state, payload) {
        state.count = payload
    },
    set_items(state, payload) {
        state.items = payload
    },
    set_toggle(state, payload) {
        state.toggle = payload
    },
    set_newNotification(state,payload){
   state.new_notification=payload;
    }
}

const actions = {
    async fetchAll(context) {
        try {
            const results = await api('get', `notification`)
            const Notifications=results.data.success?.data
           
            let rawNotifications = sessionStorage.getItem("notifications");

let userSessionNotificaitons = rawNotifications
    ? JSON.parse(rawNotifications)
    : null;
        //   console.log("thh",results.data.success.data?.count)
         if(Notifications?.count > 1) {
                    console.log("Multiple new notifications:", Notifications.count);
                    context.commit("set_newNotification", {
                        count: Notifications.count,
                        notifications: Notifications.data
                    });
                } else if(Notifications?.count === 1) {
                    console.log("Single new notification:", Notifications.data[0]);
                    context.commit("set_newNotification", {
                        count: 1,
                        notifications: Notifications.data[0]
                    });
                }
            if(userSessionNotificaitons && Notifications?.count !== 0 && Notifications?.count !== null &&  Notifications?.count !== undefined ){
                    // Since API only sends NEW notifications, we can directly set new_notification
               
                
                // merge new notification with existing ones
                console.log("notifications",Notifications);

               
                Notifications?.data.forEach(notification => {
                    userSessionNotificaitons?.data.push(notification);
                    userSessionNotificaitons.count += 1;
                });

                 sessionStorage.setItem("notifications",JSON.stringify(userSessionNotificaitons));

            }else if(!userSessionNotificaitons && Notifications?.count!==0){
                userSessionNotificaitons = Notifications
                sessionStorage.setItem("notifications",JSON.stringify( userSessionNotificaitons));
            }
            context.commit('set_items',userSessionNotificaitons ?? {count:0,data:{}} );
            context.commit('set_count', userSessionNotificaitons?.count ?? 0);
          
        } catch (err) {
            errorHandler(err)
        }
    },
    async resetLastNotificationDate(context){
             sessionStorage.setItem("notifications",null);
     api("get","notification/clear-last-check")
    },
    async updateCount(context) {
        await api('put', `notification/updatecount`)
        context.commit('set_count', 0)
    },

    async toggleNotification(context, payload) {
        const results = await api(
            'put',
            `notification/${payload.user_id}/toggle-notification`,
            payload
        )
        console.log('resultssss', results.data.success.data.notification)
        context.commit('set_toggle', results.data.success.data.notification)
    },
    async checkNotificationToggle(context, payload) {
        try {

            const results = await api(
                'get',
                `notification/checknotifition-toggle/${payload.user_id}`
            )
            context.commit('set_toggle', results.data.success.data.notification)
        } catch (err) {
            errorHandler(err)
        }
    },
}

const getters = {
    
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
